import { Tween } from '@tweenjs/tween.js';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

// the tween library is generic over the object it mutates, and this alias must stay open to every
// shape the configurators tween — narrowing it here would defeat the point of the alias.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TweenRecord = Tween<Record<string, any>>;

/**
 * TweenManager - supports multiple concurrent tweens of different types.
 */
export class TweenManager {

	//-----------------------------------------------------------------------------------------
	// Fields:
	//-----------------------------------------------------------------------------------------

	private _tweens: TweenRecord[] = [];
	
	//-----------------------------------------------------------------------------------------
	// Public Functions:
	//-----------------------------------------------------------------------------------------

	start(tween: TweenRecord): void {

		// add the tween and start it.
		this.add(tween);
		tween.start();
	}

	add(tween: TweenRecord): void {
		
		// add the tween to the array.
		this._tweens.push(tween);

		// when the tween is complete...
		tween.onComplete(() => {

			// find its index in the array.
			const index = this._tweens.indexOf(tween);

			// remove the tween from the array.
			this._tweens.splice(index, 1);
		});
	}
	
	update(): void {

		// update each tween in the array, as needed.
		for (const tween of this._tweens) {
			if (tween.isPlaying()) {
				tween.update();
			}
		}
	}
}
